import { render, staticRenderFns } from "./body-table.vue?vue&type=template&id=30dd0e9c"
import script from "./body-table.vue?vue&type=script&lang=js"
export * from "./body-table.vue?vue&type=script&lang=js"
import style0 from "./body-table.vue?vue&type=style&index=0&id=30dd0e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports